import React, { FunctionComponent } from 'react';

import DownloadAll from '../Detail/Download';
import Helpline from '../../../components/Helpline';

const Details: FunctionComponent<{}> = () => {
  return (
    <div className="flex falign-c justify-content-s">
      <DownloadAll />
      <Helpline />
    </div>
  );
};

export default Details;
